module.exports = __webpack_public_path__ + "static/media/video-scheduling-icon.a948c77e.svg";